import { WarningAmberRounded } from "@mui/icons-material";
import { Box, Fade } from "@mui/material";
import { forwardRef, PropsWithChildren, useCallback } from "react";
import { useIntl } from "react-intl";

import { PlayerFrame } from "./player-frame";

export const PlayerError = forwardRef(
  ({ errorCode, children }: PropsWithChildren<{ errorCode?: number }>, ref) => {
    const { formatMessage } = useIntl();

    const getErrorMessage = useCallback(
      (code?: number) => {
        if (code === 404) {
          return formatMessage({ id: "show_player_not_found" });
        }

        return formatMessage({ id: "show_player_unknown_error" });
      },
      [formatMessage],
    );

    return (
      <PlayerFrame ref={ref}>
        <Fade in>
          <Box flexDirection={"column"} display={"flex"} alignItems={"center"}>
            <WarningAmberRounded />
            {getErrorMessage(errorCode)}
          </Box>
        </Fade>
        {children}
      </PlayerFrame>
    );
  },
);
